/* Полоса поверх всего: место под неё освобождает --imp-bar в global.css. */
.bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  gap: var(--sp-5);
  height: var(--imp-bar, 2.25rem);
  padding: 0 var(--sp-6);
  border-bottom: var(--bw) solid var(--error-border);
  background: var(--error-bg);
  color: var(--error);
  font-size: var(--fs-sm);
}

/* Длинные адреса не должны разгонять полосу на две строки: её высота
   зафиксирована переменной, и лишний текст просто обрезается. */
.text {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.action {
  flex: none;
  border: 0;
  background: none;
  padding: 0;
  color: inherit;
  font: inherit;
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
}
